// MUI
import { Grid, Skeleton, Box } from "@mui/material";

// Third Party
import { v4 as uuidv4 } from "uuid";

// Components
import TableLoader from "@Layouts/components/Skeletons/TableLoader";

type SpiffEntrySectionLoaderProps = {
	entry?: boolean;
};

export default function SpiffEntrySectionLoader({ entry }: Readonly<SpiffEntrySectionLoaderProps>) {
	return (
		<Grid container direction="column">
			<Grid item xs={12}>
				<Box className="flex items-start justify-between">
					<Skeleton className="rounded-[6px]" variant="rectangular" width={370} height={30} />
				</Box>
			</Grid>

			{entry ? (
				<Grid item xs={12} mt={3}>
					<Box className="flex flex-col gap-2">
						<Skeleton className="rounded-[6px]" variant="rectangular" width={230} height={20} />
						<Skeleton className="rounded-[6px]" variant="rectangular" width={350} height={20} />
						<Skeleton className="rounded-[6px]" variant="rectangular" width={100} height={20} />
					</Box>
				</Grid>
			) : null}

			<Grid item xs={12} mt={entry ? 3 : 6.5}>
				<Box className="flex justify-end items-center gap-3">
					{Array.from({ length: 3 }).map(() => (
						<Skeleton key={uuidv4()} variant="circular" width={30} height={30} />
					))}
				</Box>

				<Box mb={-1} mt={1.5} className="flex items-center gap-20 pl-16">
					{Array.from({ length: 4 }).map(() => (
						<Skeleton key={uuidv4()} className="rounded-[6px]" variant="rectangular" width={100} height={20} />
					))}
				</Box>

				<TableLoader content rows={3} />
			</Grid>
		</Grid>
	);
}
